import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './code-entry.magic.css.js';
import script from './code-entry.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('magic-ui-form-field',{style:({ '--magic-code-entry-digits': _vm.length }),attrs:{"no-margin":"","data-v-test-id":"code-entry","disable-autoscroll":_vm.disableAutoscroll,"has-error":!!_vm.error,"message":_vm.error}},_vm._l((_vm.$v.digits.$each.$iter),function(code,i){return _c('magic-ui-form-field',{key:'digit' + i,ref:"inputs",refInFor:true,staticClass:"digit",attrs:{"no-margin":"","no-icon":"","part":"digit","data-v-test-id":"code-entry-field","has-error":code.digit.$error || !!_vm.error,"has-success":!code.digit.$invalid,"disable-autoscroll":_vm.disableAutoscroll}},[_c('magic-ui-number',{attrs:{"min":"0","max":"9","maxlength":"1","centered":"","focused":_vm.currentField === +i,"value":(code.digit.$model)},on:{"change":function($event){$event.stopPropagation();},"erase":function($event){return _vm.handleDelete($event, +i)},"input":[function($event){return _vm.$set(code.digit, "$model", $event.detail[0])},function($event){$event.stopPropagation();return _vm.handleInput(+i)}],"beforeinput":function($event){return _vm.handleBeforeInput($event, +i)}}})],1)}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7e89f65c_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7e89f65c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
